import { connect } from 'react-redux'

import PriceLabel from './PriceLabel'

const mapStateToProps = ({ onlyCash: isOnlyCash }) => ({ isOnlyCash })

export default connect(mapStateToProps)(PriceLabel)



// WEBPACK FOOTER //
// ./src/features/Availability/ProductCard/ProductAvailability/PriceLabel/PriceLabelContainer.js